(function () {
    'use strict';

    angular.module("imApp").factory("selectEquipmentPuService", ['$ihttp', function ($ihttp) {
        let service = {
            listSelectEquipmentPus: function (parms) {
                return $ihttp.post({
                    method: 201,
                    parameters: parms || {}
                });
            },
            saveItem: function (item) {
                return $ihttp.post({
                    method: 202,
                    parameters: item
                });
            }
        };

        return service;
    }]);
})();
